import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { useTranslations } from "next-intl";
import useStatistics from "custom-hooks/use-statistics.hook";

function OurLocation() {
  const translation = useTranslations("franchise.locations");

  const title = translation("title") || "";

  const [first, ...rest] = title.split(" ");

  const { data: statistics } = useStatistics();
  const year = new Date().getFullYear();
  return (
    <Wrapper>
      <LocationDetails>
        <div className="container">
          <LocationTitle>
            {first} <span>{rest}</span>
          </LocationTitle>
          <LocationImages>
            <StaticImage>
              <div className="circle-container">
                <div className="year circle">
                  <span className="circle-year">{year}</span>
                </div>
                <div className="locations circle">
                  <span className="circle-text">Asociados</span>
                  <span className="circle-number">
                    {statistics?.data?.agents_count || 0}
                  </span>
                </div>
                <div className="agents circle">
                  <span className="circle-text">Franquicias</span>
                  <span className="circle-number">
                    {statistics?.data?.agencies_count || 0}
                  </span>
                </div>
              </div>

              <Images
                src="/images/v2/pic/image-06.png"
                alt="Ubicación oficinas de remax republica dominicana"
              />
            </StaticImage>
          </LocationImages>
        </div>
      </LocationDetails>
      <BackgroundImage />
    </Wrapper>
  );
}

const StaticImage = styled.div`
  position: relative;

  .circle-container {
    transform: translate(85%, 80px);
  }

  .circle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    line-height: 1;
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    text-align: center;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    .circle-year {
      font-size: 1rem;
      font-weight: 800;
      color: var(--color-brand-blue-secondary);
    }

    .circle-text {
      font-size: 0.7rem;
      font-weight: 400;
      color: white;
    }

    .circle-number {
      font-size: 1.5rem;
      font-weight: 700;
      color: white;
    }
  }

  .year {
    top: 0;
    left: 0;
    z-index: 1;
    border: 6px solid var(--color-brand-blue-secondary);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-brand-blue-secondary);
    font-size: 1rem;
    font-weight: 700;
    padding-top: 10px;
  }

  .locations {
    position: absolute;
    top: 40px;
    left: 30px;
    background-color: var(--color-brand-red-main);
    z-index: 2;
    .circle-number {
      font-size: 2.3rem;
      font-weight: 700;
      color: white;
      line-height: 0.9;
    }
  }

  .agents {
    position: absolute;
    top: 20px;
    left: -60px;
    background-color: var(--color-brand-blue-main);
    z-index: 3;
    .circle-number {
      font-size: 1.5rem;
      font-weight: 700;
      color: white;
      line-height: 1;
    }
  }

  @media (max-width: 800px) {
    .circle-container {
      transform: translate(80%, 30px);
    }
  }

  @media (max-width: 508px) {
    .circle-container {
      transform: translate(80%, 10px);
    }
    .circle {
      width: 50px;
      height: 50px;
      font-size: 0.8rem;
      .circle-text {
        font-size: 0.3rem;
      }
      .circle-number {
        font-size: 0.8rem;
      }
    }
    .year {
      font-size: 0.7rem;
      padding-top: 5px;
      border-width: 3px;
      .circle-year {
        font-size: 0.7rem;
      }
    }
    .locations {
      top: 30px;
      left: 10px;
    }
    .agents {
      top: 18px;
      left: -30px;
    }
  }
`;
const Wrapper = styled.section`
  background-color: var(--color-brand-cream-primary);
  padding: 80px 0 0;
  margin-bottom: -210px;
  max-width: 100dvw;
  overflow: hidden;
`;

const LocationDetails = styled.div`
  // background: linear-gradient(
  //   var(--color-brand-cream-primary) 0%,
  //   var(--color-brand-cream-secondary) 100%
  // );
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: 400px;
  background-position: bottom left;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("/images/image-optimize/remax_rd_Asset34.webp");
`;

const LocationTitle = styled.h2`
  font-size: 1.438rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 0;
  color: var(--color-text-primary);

  & > span {
    font-weight: 300;
    color: var(--color-text-primary);
  }
`;

const LocationImages = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  margin-top: 20px;
`;

const Images = styled.img`
  width: 100%;
  border-style: none;
`;

const ImagesAbsolute = styled.img`
  position: absolute;
  right: 10%;
  top: 15%;
  width: 20%;
`;

export default OurLocation;
